import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { findFeature } from '../../findFeature'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Remove all the RoutePolylines marked for removal in a Changelog coming form the data-layer
 */
export async function changelogRemoveRoutePolylineFeatures(
  layer: VectorLayer<VectorSource>,
  markerIds: IterableIterator<string>,
) {
  nonblockingRender.reset()

  for (const markerId of markerIds) {
    await nonblockingRender.next()

    const feature = findFeature(layer, markerId)

    // if a feature is not find to be removed fail silently
    if (feature) {
      layer.getSource()?.removeFeature(feature)
    }
  }
}
